import {Platform, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    marginTop: indent,
    backgroundColor: white,
    paddingHorizontal: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    borderTopWidth: Platform.OS === 'web' ? 0 : 1,
    borderTopColor: cloudLight,
  },
  versionContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: indent / 2,
    width: '100%',
  },
});
